module.exports = __webpack_public_path__ + "img/large-purchase-icon.1278dc3d.svg";